import type {RumMiddlewareOutput} from '../types'

type RumInitArgs = Parameters<(typeof Ya.Rum)['init']>

export const rumObservableClassName = 'RumObservableRoot'

export const rumCounterInitJs = ({clck, reqid, region, ...params}: RumMiddlewareOutput['config']['rumCounter']) => {
  const settings: RumInitArgs[0] = {
    clck,
    reqid,
    beacon: true,
    sendClientUa: true,
    sendAutoResTiming: true,
    longTaskMetric: true,
  }
  const vars: RumInitArgs[1] = {
    rum_id: ['ru', params['-project'], params['-platform'], params['-page']].join('.'),
    region: String(region),
    ...params,
  }

  return `Ya.Rum.init(${[settings, vars].map(j => JSON.stringify(j)).join(',')});`
}
